import React from 'react'
import { BackTop, Layout, Spin } from 'antd'
import { connect } from 'react-redux'
// import { withRouter } from 'react-router-dom'
import classNames from 'classnames'

import TopBar from 'layouts/TopBar'
import Menu from 'layouts/Menu'
// import SocialMediaFooter from '../../components/LayoutComponents/SocialMediaFooter'
import Breadcrumbs from 'layouts/Breadcrumb'
import Settings from 'layouts/Settings'
import Footer from 'layouts/Footer'
import styles from 'layouts/Main/mainStyle.module.scss'
// import SignUpForm from '../../pages/user/signup/SignUpForm/index'
// this is the MAIN layout * attention * attention *

const mapStateToProps = ({ settings, user }) => ({
  isBorderless: settings.isBorderless,
  isRoundedCorners: settings.isRoundedCorners,
  isFixedWidth: settings.isFixedWidth,
  isMenuShadow: settings.isMenuShadow,
  isMenuTop: settings.isMenuTop,
  isSettingsOpen: settings.isSettingsOpen,
  menuSettingsValue: settings.menuSettingsValue,
  loading: user.loading,
})

// @withRouter
@connect(mapStateToProps)
class MainLayout extends React.PureComponent {
  render() {
    const {
      children,
      isSettingsOpen,
      menuSettingsValue,
      isBorderless,
      isRoundedCorners,
      isFixedWidth,
      isTopbarFixed,
      isMenuShadow,
      // isMenuTop,
      isInvestor,
      loading,
    } = this.props

    return (
      <Spin spinning={loading}>
        <Layout
          className={classNames({
            settings__borderLess: isBorderless,
            settings__TopbarFixed: isTopbarFixed,
            settings__squaredBorders: isRoundedCorners,
            settings__fixedWidth: isFixedWidth,
            settings__menuShadow: isMenuShadow,
            settings__settingsOpen: isSettingsOpen,
            settings__settingsValue: menuSettingsValue,
            //    settings__menuTop: isMenuTop,
          })}
        >
          <BackTop />
          <Menu />
          {/* <SignUpForm /> */}
          <Settings />
          <Layout>
            <Layout.Header className={styles.layoutHeader}>
              <TopBar />
            </Layout.Header>
            <Layout.Content className={styles.layoutContent}>
              <div
                className={classNames(
                  isInvestor && `${styles.investorBackground} ${styles.background}`,
                )}
              />
              <div className={`${styles.layoutBackground} ${styles.background}`} />
              <div className={styles.backgroundOverlay} />
              <div className={styles.content}>
                <Breadcrumbs />
                {children}
              </div>
            </Layout.Content>
            {!isInvestor && (
              <Layout.Footer className={styles.content}>
                <Footer />
              </Layout.Footer>
            )}
          </Layout>
        </Layout>
      </Spin>
    )
  }
}

export default MainLayout
